export interface RedirectMessageConfig {
  title: string;
  isRedirectable?: boolean;
  message: React.ReactNode;
}

const redirectMessagesConfig: Record<string, RedirectMessageConfig> = {
  NEXT: {
    title: "NEXT insurance",
    isRedirectable: true,
    message: (
      <div>
        <p className="form-descriptive-copy">Please read to customer</p>
        <div className="modal-content">
          <p>
            At GEICO Commercial, we work as an agency and write insurance through multiple partners. The partner I have for you specializes in self-servicing options through a mobile app and online chat. Phone and email support is available upon request.
          </p>
        </div>
      </div>
    ),
  },
  Nico: {
    title: "NICO insurance",
    isRedirectable: false,
    message: (
      <div>
        <p className="form-descriptive-copy"></p>
        <div className="modal-content">
          <p>
            Please quote this risk in the NICO desktop based application.
          </p>
        </div>
      </div>
    ),
  },
  Geico: {
    title: "Coverage Restrictions in Effect",
    isRedirectable: true,
    message: (
      <div>
        <div className="modal-content">
          <p>
            Physical damage coverage is currently not available in your area. Liability coverage is still available. Physical damage coverage may be added after restrictions end.
          </p>
        </div>
      </div>
    ),
  },
};

export const getRedirectMessage = (key: string): RedirectMessageConfig => {
  const config = redirectMessagesConfig[key];
  
  if (!config) {
    throw new Error(`Redirect message configuration not found for partner: ${key}`);
  }
  
  return config;
};

export const getRedirectMessageAvailableCarriers = (): string[] => {
  return Object.keys(redirectMessagesConfig);
};
